import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, GridColumn as Column, GridFilterChangeEvent, GridPageChangeEvent } from '@progress/kendo-react-grid';
import { filterBy } from '@progress/kendo-data-query';
import { updateUserListFilter, updateUserListPage, pendingUserList, updatePendingList } from 'src/actions/action.user';
import approveRejectUserButton from './ApproveRejectUserButton'
import { EditUserWrapper } from 'src/styles/edituser';
import { PendingListContext } from '../common/context';
import { Button, Typography, Grid as BootstrapGrid/* , IconButton */ } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ApplicationMain } from 'src/styles/common';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import StatusUserButton from './StatusUserButton';

class PendingUserListComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.approveRejectUser = this.approveRejectUser.bind(this);
    }

    componentDidMount() {
        this.props.updateUserListPage({
            skip: 0,
            take: 10
        });
        this.props.pendingUserList();
    }

    updateUserListFilter = (e: GridFilterChangeEvent) => {
        this.props.updateUserListFilter11(e.filter)
        this.props.updateUserListPage({skip: 0, take: 10});
    }

    updateUserListPage = (event: GridPageChangeEvent) => {
        this.props.updateUserListPage(event.page);
    }

    approveRejectUser(userId: number, status: boolean) {
        const data = { userId, status }
        this.props.updatePendingList(data)
    }

    render() {
        return (
            <ApplicationMain>
                <PendingListContext.Provider value={{
                    approveRejectUser: this.approveRejectUser
                }}>
                    <EditUserWrapper>

                        <div className="pageContainer">

                            <div className="pageHeading">
                                <BootstrapGrid container={true} spacing={0} >
                                    <BootstrapGrid item={true} xs={6}>
                                        <div className="pageTitleSection">
                                            <Link className="backButton" color="inherit" aria-label="Open drawer" to={{ pathname: `/users` }}><IconBackButton /></Link>
                                            {/* <IconButton onClick={this.back} className="backButton" color="inherit" aria-label="Open drawer">
                                                <IconBackButton />
                                            </IconButton> */}
                                            <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                                Pending User Requests
                                            </Typography>
                                        </div>
                                    </BootstrapGrid>

                                    <BootstrapGrid item={true} xs={6}>
                                        <div className="text-right">
                                            {/* <Button type="button" className="btn-blue" variant="outlined" size="medium"><Link to={{ pathname: `/users` }}>Go Back </Link></Button> */}

                                            <Button type="button" className="btn-blue" variant="outlined" size="medium"><Link to={{ pathname: `/rejecteduser` }}>Show Denied Users</Link></Button>
                                        </div>
                                    </BootstrapGrid>
                                </BootstrapGrid>
                            </div>

                            <div className="pageContent">
                                <div className="editUserScreen">
                                    <div className="kendoWrapper">
                                        {/* <Button><Link to={{ pathname: `/users` }}>Go Back </Link></Button>
                                        <span>Pending User Requests</span>
                                        <Button ><Link to={{ pathname: `/rejecteduser` }}>Show Denied Users</Link></Button> */}
                                        <Grid
                                            data={filterBy(this.props.pendingusers, this.props.filter).slice(this.props.skip, this.props.take + this.props.skip)}
                                            filterable={true}
                                            filter={this.props.filter}
                                            onFilterChange={this.updateUserListFilter}
                                            skip={this.props.skip}
                                            take={this.props.take}
                                            total={filterBy(this.props.pendingusers, this.props.filter).length}
                                            pageable={true}
                                            onPageChange={this.updateUserListPage}
                                        >
                                            <Column field="" title="Status" filterable={false} cell={StatusUserButton} />
                                            <Column field="firstName" title="First Name" filterable={true} />
                                            <Column field="lastName" title="Last Name" filterable={true} />
                                            <Column field="email" title="Email" filterable={true} />
                                            <Column field="roleText" title="Role" filterable={true} />
                                            <Column field="activeCountryName" title="Country" filterable={true} />
                                            <Column field="organization" title="Organization" filterable={true} />
                                            <Column field="isActive" title="Actions" filterable={false} cell={approveRejectUserButton} />
                                        </Grid>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </EditUserWrapper>
                </PendingListContext.Provider>
            </ApplicationMain>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        pendingusers: state.user.pendingusers,
        filter: state.user.filter,
        skip: state.user.page.skip,
        take: state.user.page.take
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        pendingUserList: () => dispatch(pendingUserList()),
        updateUserListFilter11: (data: any) => dispatch(updateUserListFilter(data)),
        updateUserListPage: (data: any) => dispatch(updateUserListPage(data)),
        updatePendingList: (data: any) => dispatch(updatePendingList(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingUserListComponent);


// WEBPACK FOOTER //
// ./src/components/users/PendingUserListComponent.tsx